export const createDeferred = <T = void>() => {
    let resolve: (value: T) => void = () => {};
    let reject: (reason: Error) => void = () => {};

    const promise = new Promise<T>((resolvePromise, rejectPromise) => {
        resolve = resolvePromise;
        reject = rejectPromise;
    });

    return { promise, resolve, reject };
};
